import { useEffect, useRef, type ReactNode } from 'react';
import { ActionIcon, Box, Portal, type DrawerProps } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import { useRightDrawerStore } from './rightDrawerStore';

type RightDrawerProps = Pick<DrawerProps, 'opened' | 'className' | 'style'> & {
  children: ReactNode;
  onClose: () => void;
  backLabel?: string;
};

/** Shared horizontal page surface for full-screen detail flows. */
export function RightDrawer({ children, onClose, backLabel = '返回', ...props }: RightDrawerProps) {
  const closeRequestId = useRightDrawerStore((state) => state.closeRequestId);
  const lastCloseRequestId = useRef(closeRequestId);

  useEffect(() => {
    if (closeRequestId !== lastCloseRequestId.current) {
      lastCloseRequestId.current = closeRequestId;
      onClose();
    }
  }, [closeRequestId, onClose]);

  return (
    <Portal>
      <Box
        component="section"
        role="dialog"
        aria-modal="false"
        className={`locs-right-drawer ${props.className ?? ''}`}
        style={props.style}
        data-opened={props.opened || undefined}
        data-closed={!props.opened || undefined}
      >
        <Box className="locs-right-drawer__header">
          <ActionIcon variant="subtle" color="gray" size="lg" aria-label={backLabel} onClick={onClose}>
            <IconChevronLeft size={20} stroke={1.5} />
          </ActionIcon>
        </Box>
        <Box className="locs-right-drawer__body">{children}</Box>
      </Box>
    </Portal>
  );
}
